// extracted by mini-css-extract-plugin
module.exports = {"container":"userDetailHeader_container__3U1Ul"};